/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSIGNINGOPTIONS = {
    ESigning: '1',
    InOfficeESigning: '2',
    DownloadAndSign: '3'
} as const;
export type IAPSIGNINGOPTIONS = typeof IAPSIGNINGOPTIONS[keyof typeof IAPSIGNINGOPTIONS];


export function IAPSIGNINGOPTIONSFromJSON(json: any): IAPSIGNINGOPTIONS {
    return IAPSIGNINGOPTIONSFromJSONTyped(json, false);
}

export function IAPSIGNINGOPTIONSFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSIGNINGOPTIONS {
    return json as IAPSIGNINGOPTIONS;
}

export function IAPSIGNINGOPTIONSToJSON(value?: IAPSIGNINGOPTIONS | null): any {
    return value as any;
}

